<!--
  This is a temporary component to display the taxonomy items in a test page.
-->
<template>
  <ul v-if="items && items.length > 0">
    <li v-for="item in items" :key="item.slug">
      <div>Name: <sc-text :field="item.fields.name" /></div>
      <div>Description: <sc-text :field="item.fields.description" /></div>
      <div>Slug: <sc-text :field="item.fields.slug" /></div>
      <div>Legacy ID: <sc-text :field="item.fields.legacyID" /></div>
    </li>
  </ul>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-TaxonomyItems',
  props: {
    items: {
      type: Array
    }
  },
  components: {
    ScText: Text
  }
};
</script>
